import { MEMBER_TYPE_KEY } from 'utils/constants';
import i18n from '../../i18n';
export const UserTypeEnum = Object.freeze({
    ADMIN: 1, // 项目管理员
    MEMBER: 2, // 开发人员（或运营人员）
    STATS_VIEWER: 4, // 受限查看人员
    /** 数据合规受限管理员 */
    COMPLIANCE_ADMIN: 11,
    /** 数据合规受限成员 */
    COMPLIANCE_MEMBER: 12,
    hasAdminPermission(type) {
        return Number(type) === UserTypeEnum.ADMIN || Number(type) === UserTypeEnum.COMPLIANCE_ADMIN;
    },
});
// 用户类型列表
export const UserTypeList = [
    {
        label: i18n.t('MEMBERMANAGE.admin'),
        value: MEMBER_TYPE_KEY.admin,
        type: UserTypeEnum.ADMIN,
        isOperator: 0,
    },
    {
        label: i18n.t('MEMBERMANAGE.complianceAdmin'),
        value: MEMBER_TYPE_KEY.complianceAdmin,
        type: UserTypeEnum.COMPLIANCE_ADMIN,
        isOperator: 0,
        extraDescription: i18n.t('MEMBERMANAGE.complianceDescription'),
    },
    {
        label: i18n.t('MEMBERMANAGE.normal'),
        value: MEMBER_TYPE_KEY.normal,
        type: UserTypeEnum.MEMBER,
        isOperator: 0,
    },
    {
        label: i18n.t('MEMBERMANAGE.complianceMember'),
        value: MEMBER_TYPE_KEY.complianceMember,
        type: UserTypeEnum.COMPLIANCE_MEMBER,
        isOperator: 0,
        extraDescription: i18n.t('MEMBERMANAGE.complianceDescription'),
    },
    {
        label: i18n.t('MEMBERMANAGE.operator'),
        value: MEMBER_TYPE_KEY.operator,
        type: UserTypeEnum.MEMBER,
        isOperator: 1,
    },
    {
        label: i18n.t('MEMBERMANAGE.statsViewer'),
        value: MEMBER_TYPE_KEY.statsViewer,
        type: UserTypeEnum.STATS_VIEWER,
        isOperator: 0,
    },
];
export const UserTypeUtil = Object.freeze({
    fromMemberTypeKey(memberTypeKey) {
        const matched = UserTypeList.find(x => x.value === memberTypeKey);
        if (matched === undefined) {
            const errMsg = `fromMemberTypeKey, Invalid type ${memberTypeKey}`;
            console.error(errMsg);
            throw Error(errMsg);
        }
        return { userType: matched.type, isOperator: matched.isOperator };
    },
    toMemberTypeKey(userType, isOperator) {
        const type = Number(userType);
        let matched = UserTypeList.find(x => x.type === type && x.isOperator === isOperator)
            || UserTypeList.find(x => x.type === type); // 兼容type匹配但是isOperator不匹配的
        if (matched === undefined) {
            console.error(`toMemberTypeKey, Invalid type ${type}`);
            return MEMBER_TYPE_KEY.UNKNOWN;
        }
        return matched.value;
    },
});
